const CANVAS_KEYBOARD_OWNER_SELECTOR = "[data-canvas-keyboard-owner]";
const CANVAS_KEYBOARD_INTERACTIVE_TARGET_SELECTOR = [
  "input",
  "textarea",
  "select",
  "button",
  "a[href]",
  "[contenteditable]:not([contenteditable='false'])",
  "[role='button']",
].join(",");

export function isCanvasKeyboardOwnerTarget(
  target: EventTarget | null,
  boundary?: Element
): boolean {
  const owner = target instanceof Element && target.closest(CANVAS_KEYBOARD_OWNER_SELECTOR);
  return Boolean(owner && (!boundary || boundary.contains(owner)));
}

export function isCanvasKeyboardControlTarget(
  target: EventTarget | null,
  boundary?: Element
): boolean {
  if (!(target instanceof Element)) {
    return false;
  }
  const interactiveTarget = target.closest(CANVAS_KEYBOARD_INTERACTIVE_TARGET_SELECTOR);
  return Boolean(interactiveTarget && (!boundary || boundary.contains(interactiveTarget)));
}

export function isCanvasKeyboardInteractiveTarget(
  target: EventTarget | null,
  boundary?: Element
): boolean {
  return (
    isCanvasKeyboardControlTarget(target, boundary) || isCanvasKeyboardOwnerTarget(target, boundary)
  );
}
